import { render, staticRenderFns } from "./SfStep.vue?vue&type=template&id=6d9f3bfe"
import script from "./SfStep.vue?vue&type=script&lang=js"
export * from "./SfStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  "836d520c"
  
)

export default component.exports